import { query, } from "../../defaults/fetch";
import {useState,useEffect} from "react";


export const useRoles =()=>{
    const [roles,setRoles] = useState([]);

    useEffect(()=>{
        const fetchRoles = async()=>{
            const url = `system/get-roles`;
            const {data} = await query(url);
            setRoles(data);
        }

        fetchRoles();
    },[]);

    return roles;
}